<template>
  <div :class="$style.registration">
    <form @submit.prevent="handleSubmit">
      <h1
        v-if="uniqueUsernameError"
        :class="$style.title"
      >
        Номер уже зарегистрирован,<br>
        нажмите войти
      </h1>
      <h1
        v-else
        :class="$style.title"
      >
        Регистрация
      </h1>

      <!--  Нам нужен этот инпут для правильного сохранения номера телефона вместе с кодом страны -->
      <input
        v-show="false"
        type="text"
        name="tel"
        :value="form.username"
        autocomplete="username"
        @input="browserAutofill"
      >

      <PFPhoneField
        ref="phoneInput"
        v-model="form.username"
        :error="$v.form.username.$error"
        :error-message="[
          { valid: $v.form.username.phoneNumber, message: 'Пожалуйста, введите корректный номер телефона. Например, +7 (999) 000-00-00' },
          { valid: $v.form.username.required, message: 'Это обязательное поле' }
        ]"
        @click.stop="handlePhoneFieldClick"
        @input="handlePhoneFieldInput"
        @focus="scrollFurther"
      />

      <Button
        v-if="uniqueUsernameError"
        full-width
        variant="primary"
        :loading="loading"
        :class="$style.btn"
        @click.stop
      >
        Войти
      </Button>
      <Button
        v-else
        full-width
        variant="primary"
        :loading="loading"
        :class="$style.btn"
        @click.stop="handleRegisterBtnClick"
      >
        Зарегистрироваться
      </Button>
      <p v-if="wrongCodeError" :class="$style.error">
        Неверный логин или пароль
      </p>
      <p v-if="error" :class="$style.error">
        Что-то пошло не так. Попробуйте позже
      </p>
      <span v-if="errMsgWithBot" :class="$style.error">
        Возникли проблемы, напишите в поддержку
        <a
          href="https://t.me/YourgoodWidget_bot"
          target="_blank"
          style="text-decoration: none; color: inherit;"
          onclick="return false;"
        >@YourgoodWidget_bot</a>
      </span>
    </form>
  </div>
</template>

<script>
import required from 'vuelidate/lib/validators/required'
import debounce from 'lodash/debounce'
import PFPhoneField from '@/components/OldUI/newUI/PFPhoneField'
import Button from '@/components/OldUI/shared/Button'

import { phoneNumber, uniqueUsername } from '@/plugins/vuelidate/rules'
import * as authApi from '@/api/authApi'
import { TooManyRequestsError } from '@/api/common.errors'

export default {
  name: 'Register',
  components: {
    PFPhoneField,
    Button
  },
  layout: 'auth',
  middleware ({ redirect, store }) {
    if (store.getters['auth/isAuthenticated']) {
      redirect({ name: 'settings' })
    }
  },
  validations: {
    form: {
      username: {
        required,
        phoneNumber
      }
    }
  },
  data: () => ({
    loading: false,
    error: false,
    uniqueUsernameError: false,
    form: {
      username: ''
    },

    wrongCodeError: false,
    errMsgWithBot: false
  }),
  head: {
    meta: [
      { hid: 'description', name: 'description', content: 'Зарегистрируйся в сервисе Yourgood Widget по номеру телефона и установи на сайт кнопку WhatsApp бесплатно.' }
    ]
  },
  watch: {
    'form.username': debounce(async function (username) {
      if (!username) {
        this.uniqueUsernameError = false
        return
      }

      this.uniqueUsernameError = !(await uniqueUsername(username))
    }, 300)
  },
  created () {
    const { u: usernameToInsert } = this.$route.query
    if (usernameToInsert) {
      this.form.username = usernameToInsert
    }
  },
  mounted () {
    this.$store.dispatch('statisticsInner/createEvent', {
      event: 'register-enter'
    })
    setTimeout(() => {
      this.$refs.phoneInput.focus()
    }, 0)
  },
  methods: {
    async handleSubmit () {
      this.$v.$touch()
      if (this.$v.form.username.$error) {
        return this.fireStatisticsErrorReport()
      }

      if (this.uniqueUsernameError) {
        await this.handleLogin()
      } else {
        await this.handleRegistration()
      }
    },
    async handleRegistration () {
      this.loading = true
      try {
        const sendCodeEither = await this.$store.dispatch('auth/registerSendCode', this.form)

        sendCodeEither.mapRight(() => {
          this.$store.dispatch('statisticsInner/createEvent', {
            event: 'register-send-success'
          })
          window.ym(process.env.YANDEX_YM_ID, 'reachGoal', 'registration_verify')

          this.$router.push({ name: 'registerConfirm', query: this.$route.query })
          this.error = false
          this.errMsgWithBot = false
        })
        sendCodeEither.mapLeft((e) => {
          if (e instanceof TooManyRequestsError) {
            this.$router.push({ name: 'registerConfirm', query: this.$route.query })
            this.errMsgWithBot = true
            return
          }
          this.error = true
        })
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },
    async handleLogin () {
      this.loading = true
      this.error = false

      try {
        this.$store.dispatch('statisticsInner/createEvent', {
          event: 'register-btn-login-click'
        })
        const loginEither = await authApi.loginSendSms(this.form)

        loginEither.mapRight(() => {
          this.$router.push({ name: 'loginConfirm' })
          // window.ym(process.env.YANDEX_YM_PRIVATE_ID, 'reachGoal', 'register_login_success')
        })
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },
    scrollFurther () {
      if (this.$device.isMobile) {
        setTimeout(() => {
          window.scrollTo({ top: document.documentElement.scrollTop + 50, behavior: 'smooth' })
        }, 200)
      }
    },
    browserAutofill (e) {
      this.form.username = e.target.value
    },
    fireStatisticsErrorReport () {
      if (!phoneNumber(this.form.username)) {
        this.$store.dispatch('statisticsInner/createEvent', {
          event: 'register-phone-number-format-error'
        })
      }
      if (this.uniqueUsernameError) {
        this.$store.dispatch('statisticsInner/createEvent', {
          event: 'register-phone-number-unique-error'
        })
      }
    },
    async handleRegisterBtnClick () {
      await this.$store.dispatch('statisticsInner/createEvent', {
        event: 'register-btn-click'
      })
    },
    async handlePhoneFieldClick () {
      await this.$store.dispatch('statisticsInner/createEvent', {
        event: 'register-phone-number-field-click'
      })
    },
    handlePhoneFieldInput: debounce(async function () {
      await this.$store.dispatch('statisticsInner/createEvent', {
        event: 'register-phone-number-field-typing'
      })
    }, 500),
    async handlePasswordFieldClick () {
      await this.$store.dispatch('statisticsInner/createEvent', {
        event: 'register-password-field-click'
      })
    },
    handlePasswordFieldInput: debounce(async function () {
      await this.$store.dispatch('statisticsInner/createEvent', {
        event: 'register-password-field-typing'
      })
    }, 500)
  }
}
</script>

<style module lang="scss">
@import "assets/scss/shared";

.registration {
  text-align: center;
  flex-grow: 1;
}

.title {
  margin-top: 0;
  margin-bottom: 16px;
}

.btn {
  margin-top: 24px;
}

.error {
  color: $ui-delete;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
